<template>
    <div>
        <div class="header-return">
            <el-row :gutter="20">
                <el-col :span="2">
                    <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                </el-col>
                <el-col :span="10" :offset="12">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap"
                             :size="GCONFIG.styleElFormSize">
                        <el-form-item label="平台">
                            <el-select v-model="formInline.platformId" placeholder="平台" :disabled="platformDisabled">
                                <el-option v-for="item in platformData"
                                           :key="item.platformId"
                                           :label="item.platformName"
                                           :value="item.platformId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="getCatList()" size="mini" class="header-btn">查询</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="queryCategory" size="mini" class="header-btn">查询资质审核</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="success" @click="uploadCategory" size="mini" class="header-btn">上传类目资质</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
        </div>
        <el-table :data="list" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading"  max-height="650">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column label="三级类目ID" prop="third_cat_id"></el-table-column>
            <el-table-column label="三级类目名称" prop="third_cat_name"></el-table-column>
            <el-table-column label="类目资质" prop="qualification"></el-table-column>
            <el-table-column prop="qualification_type" label="类目资质类型">
                <template slot-scope="scope">
                    <el-tag size="mini" v-if="scope.row.qualification_type==0"  effect="plain">不需要</el-tag>
                    <el-tag size="mini" v-if="scope.row.qualification_type==1" type="danger" effect="plain">必填</el-tag>
                    <el-tag size="mini" v-if="scope.row.qualification_type==2" type="success" effect="plain">选填</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="product_qualification" label="商品资质">
            </el-table-column>
            <el-table-column prop="product_qualification_type" label="商品资质类型">
                <template slot-scope="scope">
                    <el-tag size="mini" v-if="scope.row.qualification_type==0"  effect="plain">不需要</el-tag>
                    <el-tag size="mini" v-if="scope.row.qualification_type==1" type="danger" effect="plain">必填</el-tag>
                    <el-tag size="mini" v-if="scope.row.qualification_type==2" type="success" effect="plain">选填</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="二级类目ID" prop="second_cat_id"></el-table-column>
            <el-table-column label="二级类目名称" prop="second_cat_name"></el-table-column>
            <el-table-column label="一级类目ID" prop="first_cat_id"></el-table-column>
            <el-table-column label="一级类目名称" prop="first_cat_name" fixed="right"></el-table-column>
        </el-table>
        <el-dialog title="上传类目资质" :visible.sync="showDialog" center>
            <el-form :model="category" label-width="80px">
                <el-form-item label="营业执照或组织机构代码证" :required="true">
                    <uploadComponents v-model="category.audit_req.license" :urlType="2"></uploadComponents>
                </el-form-item>
                <el-form-item label="一级类目">
                    <el-select v-model="category.audit_req.category_info.level1" clearable filterable placeholder="一级类目" @change="firstCatChange">
                        <el-option
                                v-for="item in firstCatList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="二级类目">
                    <el-select v-model="category.audit_req.category_info.level2" clearable filterable placeholder="二级类目" @change="secondtCatChange">
                        <el-option
                                v-for="item in tempSecondCatList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="三级类目">
                    <el-select v-model="category.audit_req.category_info.level3" clearable filterable placeholder="三级类目" @change="thirdtCatChange">
                        <el-option
                                v-for="item in tempThirdCatList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item
                        v-for="(domain, index) in domains"
                        :label="'资质材料图片' + index"
                        :key="domain.key"

                >
                    <uploadComponents v-model="domain.value" :urlType="2"></uploadComponents>
                    <el-button size="mini"  @click="addDomain">增加</el-button>
                    <el-button size="mini" @click.prevent="removeDomain(domain)">删除</el-button>
                </el-form-item>

                <el-form-item>
                    <el-button size="mini"  @click="showDialog = false">取 消</el-button>
                    <el-button size="mini"  type="primary" @click="save()">确 定</el-button>

                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog title="查询类目审核结果" :visible.sync="categoryResult" center>
            <el-form  label-width="80px">
                <el-form-item label="提交审核资质时 回传审核 audit_id" :required="true">
                    <el-input v-model=audit_id clearable placeholder="提交审核资质时 回传审核 audit_id" ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="categoryResult = false">取 消</el-button>
                    <el-button type="primary" @click="get_audit_result()">查询</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import draggable from 'vuedraggable'
    import uploadComponents from '@/components/upload';
    import {
        register,getSkuCatList,getPlatformList2,audit_category,get_audit_category,getAllSkuCatList
    } from '../../api/api';
    export default {
        data() {
            return {
                showDialog: false,
                showUploadLicense:false,
                selectType:1,
                formInline: {
                    platformId: 4
                },
                categoryResult:false,
                audit_id:0,
                loading:true,
                category:{
                    audit_req:
                        {
                            license: '',
                            category_info:
                            {
                                level1: '', // 一级类目
                                level2: '', // 二级类目
                                level3: '', // 三级类目
                                certificate: [] // 资质材料
                            }
                        }
                },
                list: [],
                thirdtCatList:[],
                tempThirdCatList:[],
                secondtCatList:[],
                tempSecondCatList:[],
                firstCatList:[],
                domains: [{
                    value: ''
                }]
            }
        },
        created() {

        },
        components:{
            uploadComponents
        },
        computed:{

        },
        //挂载时候执行
        mounted(){
            this.getPlatfrom();
            this.getCatList();
            this.getList();
        },
        methods: {
            getList(){
                //查询模板列表
                this.loading=true;
                getSkuCatList(this.formInline).then((res) => {
                    this.loading=false;
                    console.log(res);
                    if (res.data.success) {
                        this.thirdtCatList = res.data.value.thirdtCat;
                        this.secondtCatList = res.data.value.secondtCat;
                        this.firstCatList = res.data.value.firstCat;
                        this.list= res.data.value.thirdtCatList;
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            getCatList(){
                //查询模板列表
                getAllSkuCatList(this.formInline).then((res) => {
                    console.log(res);
                    if (res.data.success) {
                        this.list= res.data.value;
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            registerData(){
                register(this.formInline).then((res) => {
                    console.log(res);
                    if (res.data.success) {
                        this.$message({
                            message: '注册成功',
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            save(){
                this.category.audit_req.category_info.certificate=[];
                for(let j = 0,len=this.domains.length; j < len; j++) {
                    this.category.audit_req.category_info.certificate.push(this.domains[j].value);
                }
                audit_category({data:JSON.stringify(this.category)}).then((res) => {
                    console.log(res);
                    if (res.data.success) {
                        this.$message({
                            message: res.data.value,
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            queryCategory(){
                this.categoryResult=true;
                this.showDialog=false;
            },
            uploadCategory(){
                this.categoryResult=false;
                this.showDialog=true;
            },
            firstCatChange(id){
                this.tempSecondCatList=this.secondtCatList.filter(function (item) {
                    return item.parentId==id;
                });
            },
            secondtCatChange(id){
                this.tempThirdCatList=this.thirdtCatList.filter(function (item) {
                    return item.parentId==id;
                });
            },
            thirdtCatChange(id){

            },
            selectlicense(){
                this.dialogFormVisiblePicAdd=true;
                this.selectFileList=[];
                this.selectType=1;
            },
            selectcertificate(){
                this.dialogFormVisiblePicAdd=true;
                this.selectFileList=[];
                this.category.audit_req.category_info.certificate=[]
                this.selectType=2;
            },
            getUrl(path){
                category.audit_req.license=path.pop().imagePath;
                this.showUploadLicense=false;
            },
            get_audit_result(){
                get_audit_category({platformId:this.formInline.platformId,audit_id:this.audit_id}).then((res) => {
                    console.log(res);
                    if (res.data.success) {
                        this.$message({
                            message: res.data.value,
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            getPlatfrom(){
                //初始化首页数据
                getPlatformList2().then((res) => {
                    this.platformData = res.data;
                });
            },
            removeDomain(item) {
                var index = this.domains.indexOf(item)
                if (index !== -1) {
                    this.domains.splice(index, 1)
                }
            },
            addDomain() {
                this.domains.push({
                    value: '',
                    key: Date.now()
                });
            },
            formatDate(datetime) {
                var date = new Date(datetime);
                var year = date.getFullYear(),
                    month = ("0" + (date.getMonth() + 1)).slice(-2),
                    sdate = ("0" + date.getDate()).slice(-2),
                    hour = ("0" + date.getHours()).slice(-2),
                    minute = ("0" + date.getMinutes()).slice(-2),
                    second = ("0" + date.getSeconds()).slice(-2);
                // 拼接
                var result = year + "-" + month + "-" + sdate + " " + hour + ":" + minute + ":" + second;
                // 返回
                return result;
            },
            returnHistory(){
                window.history.back()
            }
        }
    }
</script>
<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>


// WEBPACK FOOTER //
// src/views/minishop/productCategory.vue